import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const RoadworthinessMaintenancePolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  maintenanceManagerContact,
  complianceOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Roadworthiness_and_Maintenance_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Roadworthiness & Maintenance Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        The purpose of this policy is to ensure that all vehicles operated by {clientName || "the Company"} remain safe, legal, and reliable through effective maintenance and regular inspections.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all vehicles in the company fleet, including HGVs, PSVs, and company cars.
      </p>

      <h4 className="section-title">3. Daily Walkaround Checks</h4>
      <ul>
        <li>Drivers must carry out daily walkaround checks before use, inspecting tyres, lights, brakes, steering, and other safety-critical components.</li>
        <li>Any defects or issues must be reported immediately to the maintenance department.</li>
        <li>Drivers must complete and submit defect reporting forms as required.</li>
      </ul>

      <h4 className="section-title">4. Planned Preventative Maintenance (PPM)</h4>
      <ul>
        <li>Vehicles will be maintained according to manufacturers' schedules and regulatory requirements.</li>
        <li>PPM schedules will include routine inspections, servicing, and replacement of wear parts.</li>
        <li>Maintenance records will be kept accurately and made available for audits.</li>
      </ul>

      <h4 className="section-title">5. Defect Rectification and Vehicle Off Road (VOR)</h4>
      <ul>
        <li>All defects classified as major or safety-critical must be rectified before the vehicle is returned to service.</li>
        <li>Vehicles deemed unsafe will be declared Vehicle Off Road (VOR) and clearly marked.</li>
        <li>The VOR process will include documentation, repair tracking, and communication to relevant personnel.</li>
      </ul>

      <h4 className="section-title">6. Compliance and Legal Requirements</h4>
      <ul>
        <li>Vehicles must comply with all relevant legislation including the Road Traffic Act, PSV/HGV licensing, and MOT requirements.</li>
        <li>The maintenance department will ensure adherence to legal standards and prepare vehicles for inspections and audits.</li>
      </ul>

      <h4 className="section-title">7. Roles and Responsibilities</h4>
      <p className="section-content"><strong>Maintenance Manager:</strong> Oversees all maintenance activities and ensures compliance. Contact: {maintenanceManagerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Compliance Officer:</strong> Monitors regulatory compliance and supports audits. Contact: {complianceOfficerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Drivers:</strong> Responsible for daily checks and defect reporting.</p>

      <h4 className="section-title">8. Record Keeping and Documentation</h4>
      <p className="section-content">
        Accurate maintenance logs, inspection reports, and defect records will be maintained and reviewed regularly.
      </p>

      <h4 className="section-title">9. Review and Continuous Improvement</h4>
      <p className="section-content">
        This policy will be reviewed annually or after significant incidents to ensure effectiveness and compliance with evolving regulations.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will comply with the Roadworthiness & Maintenance Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default RoadworthinessMaintenancePolicy;